<template>
    <div>
        <NavBar />

        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Contact List
                    </h1>
                </div>
            </header>
        </div>

        <main class="container mx-auto">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0">
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-2/3">
                            <div class="flex flex-wrap">
                                <div class="w-full md:w-1/2 text-center px-2">
                                    <label for="uploadContactList">
                                        <div class="rounded overflow-hidden hover:shadow py-2 bg-white  cursor-pointer">
                                            <svg class="mx-auto h-10 w-10 mt-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                                            </svg>

                                            <div class="px-6 py-4 text-center">
                                                <div class="font-bold text-xl mb-2">Upload Contact List</div>
                                                <p class="text-gray-700 text-sm">
                                                    Upload a new contact list
                                                </p>
                                            </div>
                                        </div>
                                    </label>

                                    <input
                                        id="uploadContactList"
                                        name="campaign_contacts[type]"
                                        type="radio"
                                        value="upload_list"
                                        v-model="contactListType"
                                        v-show="false"
                                    >
                                </div>

                                <div class="w-full md:w-1/2 text-center px-2">
                                    <input
                                        id="existingContactList"
                                        name="campaign_contacts[type]"
                                        type="radio"
                                        value="existing_list"
                                        v-model="contactListType"
                                        v-show="false"
                                    >

                                    <label for="existingContactList">
                                        <div class="rounded overflow-hidden hover:shadow py-2 bg-white  cursor-pointer">
                                            <svg class="mx-auto h-10 w-10 mt-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                            </svg>

                                            <div class="px-6 py-4 text-center">
                                                <div class="font-bold text-xl mb-2">Choose Contact List</div>
                                                <p class="text-gray-700 text-sm">
                                                    Choose from existing contact lists
                                                </p>
                                            </div>
                                        </div>
                                    </label>
                                
                                </div>
                            </div>

                            <div class="mx-2 my-4" v-if="contactListType != ''">
                                <div v-if="contactListType === 'upload_list'">
                                    Upload
                                </div>
                                <div v-else-if="contactListType === 'existing_list'">
                                    <h3 class="font-bold text-xl">Available Contact Lists</h3>

                                    <div v-for="list in lists" :key="list.id" @click="selectList(list.id)" class="bg-gray-200 py-4 px-4 rounded cursor-pointer">
                                        {{ list.description }} 
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-full md:w-1/3">
                            <Summary :summary="summary" />

                            <button
                                class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-2 px-4 rounded my-4"
                                @click="save"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "../components/NavBar";
import Summary from "../components/Summary";

export default {
    name: "ContactLists",
    data() {
        return {
            blocked: false,
            summary: {
                "message_type": "",
                "contact_list_id": "",
                "contact_list_type": "",
            }
        }
    },
    components: {
        NavBar,
        Summary,
    },
    methods: {
        selectList(id) {
            if(this.selectedList !== id) {
                const payload = {
                    prop: "selectedList",
                    val: id
                };
                const contactList = this.contactList(id);
                this.summary.contact_list_id = contactList.description;
                this.$store.commit("change", payload);
            }
        },
        save() {
            this.$router.push(this.nextRoute);
        }
    },
    mounted() {
        this.$store.dispatch("loadLists");
        this.summary.message_type = this.messageTypeFormatted;

        const contactList = this.contactList(this.selectedList);

        if(contactList != undefined) {
            this.summary.contact_list_type = this.contactListType;
            this.summary.contact_list_id = this.contactList(this.selectedList).description;
        }
    },
    computed: {
        nextRoute() {
            return `${this.$route.meta.link}`
        },
        contactListType: {
            get() {
                return this.$store.getters.contactListType;
            },
            set(value) {
                const payload = {
                    prop: "contactListType",
                    val: value
                };

                this.$store.commit("change", payload);
                this.summary.contact_list_type = this.contactListType;

                if(value === "upload_list"){
                    this.$store.commit("change", { prop: "selectedList", val: "" });
                    this.summary.contact_list_id = "";
                }
            },
        },
        ...mapGetters([
                "lists",
                "selectedList",
                "messageTypeFormatted",
                "contactList",
            ]),
    },
}
</script>